import dayjs from "dayjs";
import PAAttendee from "./Attendee";


class Photo {
    constructor(){

        const _temp = PAAttendee.generateRandomString(24);
        this.temp_id = _temp;
        this.id = _temp;
        this.event_id = "";
        this.attendee_id = "";
        this.file = null;
        this.file_name = "";
        this.file_type = "";
        this.file_size = 0;
        this.height = 0;
        this.width = 0;
        this.thumbnail_data = "";
        this.full_data = "";
        this.caption = "";
        this.private = false;
        this.sharable = false;
        this.share_with = [];       //this is a list of email addresses
        this.link_with_sections = [];
        this.photo_album = false;   //this will make it a part of the event cover image
        this.full_size_uploaded = false;
        this.thumbnail_finished = false;
        this.gcs_path = "";         //this is the address for the Google Cloud Storage image
        this.last_modified = 0;
        this.status = 0;
    }

}

export default Photo;
